
uniform vec3 uColor;
uniform float uCount;
uniform float uRadius;
uniform float uTheta;


varying vec2 vUv;
varying vec3 vColor;






void main() {
    vUv = uv;

    // angle proportionnel à la coordonnée X
    float angle = position.x / uRadius;

    // coordonnées courbées
    float newX = sin(angle) * uRadius;
    // float newZ = (cos(angle) * uRadius) - uRadius; // -uRadius pour recentrer
    float newZ = uRadius - cos(angle) * uRadius;
    vec3 newPosition = vec3(position.x, position.y, newZ);

    // gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1);
    gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0);
}
